import { Action } from '@ngrx/store';
import { IProduct, Order } from '@cemex-core/cmx-api';
import { AltUnit } from '../../order-builder/modules/specification/models/units';

export enum OneClickUnitsActionTypes {
  LOAD_UNITS_BUILDER = '[One Click] Load units builder',
  LOAD_UNITS = '[One Click] Load units',
  LOAD_UNITS_COMPLETE = '[One Click] Load units completed',
  SELECT_UNITS = '[One Click] Select units',
  RESET = '[One Click] units reset',
}

export class OneClickLoadUnitsBuilderAction implements Action {
  readonly type = OneClickUnitsActionTypes.LOAD_UNITS_BUILDER;

  constructor(public payload: IProduct, public index: number) {}
}

export class OneClickLoadUnitsAction implements Action {
  readonly type = OneClickUnitsActionTypes.LOAD_UNITS;

  constructor(public payload: Order) {}
}

export class OneClickLoadUnitsCompleteAction implements Action {
  readonly type = OneClickUnitsActionTypes.LOAD_UNITS_COMPLETE;

  constructor(public payload: AltUnit[]) {}
}

export class OneClickSelectUnitsAction implements Action {
  readonly type = OneClickUnitsActionTypes.SELECT_UNITS;

  constructor(public payload: AltUnit) {}
}

export class OneClickResetUnitsAction implements Action {
  readonly type = OneClickUnitsActionTypes.RESET;

  constructor() {}
}

export type OneClickUnitsActions =
  | OneClickLoadUnitsBuilderAction
  | OneClickLoadUnitsAction
  | OneClickLoadUnitsCompleteAction
  | OneClickSelectUnitsAction
  | OneClickResetUnitsAction;
